import {Chip} from '@dropbox/dig-components/chip';
import {Truncate} from '@dropbox/dig-components/truncate';
import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import {Box, Split} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {PinLine} from '@dropbox/dig-icons/assets';
import {NewsPost} from 'client/models/NewsPost';
import {LabelGroup} from 'components/DSYS/LabelGroup';
import {format} from 'date-fns';
import {t} from 'i18next';

import styles from './NewsRow.module.css';
import {NewsThumbnail} from './NewsThumbnail';

interface NewsRowProps {
  id: NewsPost['id'];
  title: NewsPost['title'];
  category: NewsPost['category'];
  creationDate: NewsPost['created_at'];
  postAt: NewsPost['post_at'];
  is_draft?: boolean;
  is_read?: boolean;
  isCategoryView?: boolean;
  isPinned?: boolean;
}

export const NewsRow = ({
  id,
  title,
  category,
  creationDate,
  is_draft,
  postAt,
  isPinned,
  isCategoryView,
}: NewsRowProps) => {
  const date = new Date(creationDate);
  const options = {year: 'numeric', month: 'long', day: 'numeric'};
  const formattedDate = date.toLocaleDateString('en-US', options as Intl.DateTimeFormatOptions);

  const categoryString = category[0] ? category[0].name : '';
  const categoryLabel = isCategoryView ? '' : categoryString ? categoryString + ' • ' : '';

  return (
    <LabelGroup
      size="medium"
      withText={<Truncate lines={2}>{title}</Truncate>}
      withSubtext={
        is_draft ? (
          <DraftSubtext categoryString={categoryString} postAt={postAt} isPinned={isPinned} />
        ) : (
          <Split gap="4" alignY="center">
            {isPinned && (
              <Split.Item>
                <UIIcon src={PinLine} size="small" className={atoms({color: 'Text Subtle'})} />
              </Split.Item>
            )}
            <Split.Item>
              <Box>{categoryLabel + formattedDate}</Box>
            </Split.Item>
            {/* {is_read && (
              <Split.Item>
                <Box
                  as={UIIcon}
                  marginTop="2"
                  src={CheckmarkCircleLine}
                  size="small"
                  color="Text Subtle"
                />
              </Split.Item> */}
          </Split>
        )
      }
      withLeftAccessory={<NewsThumbnail id={id} isNewsFeed />}
    />
  );
};

export const DraftSubtext = ({
  categoryString,
  postAt,
  isPinned,
}: {
  categoryString: string;
  postAt: NewsPost['post_at'];
  isPinned?: boolean;
}) => (
  <Box className={styles.subtext}>
    {isPinned && <UIIcon src={PinLine} size="small" className={atoms({color: 'Text Subtle'})} />}
    {categoryString}
    {postAt ? (
      <Text size="small" color="faint">
        {categoryString.length ? ' • ' : ''}
        {t('draft_scheduled', {
          date: format(new Date(postAt), "MMMM d 'at' haaa"),
        })}
      </Text>
    ) : (
      <Chip className={styles.draftChip} size="small">
        <Chip.Content>{t('draft')}</Chip.Content>
      </Chip>
    )}
  </Box>
);
